(function () {
    const overlay = document.getElementById('globo-custom-overlay');
    let overlayDelay;
    let hideDelay;

    // Exit immediately if overlay doesn't exist OR if screen is not desktop
    if (!overlay || window.innerWidth <= 990) return;

    document.addEventListener('mouseover', function (e) {
        // Re-check width in case user resized window
        if (window.innerWidth <= 990) return;

        const isTopLevelItem = e.target.closest('.gm-level-0');
        const isSubMenu = e.target.closest('.gm-submenu');

        if (isTopLevelItem || isSubMenu) {
            clearTimeout(hideDelay); 
            clearTimeout(overlayDelay); 

            if (window.getComputedStyle(overlay).display === 'none') {
                overlayDelay = setTimeout(() => {
                    overlay.style.display = 'block';
                    setTimeout(() => {
                        overlay.style.opacity = '1';
                    }, 10);
                }, 170);
            }
        }
    });

    document.addEventListener('mouseout', function (e) {
        if (window.innerWidth <= 990) return;

        const movingToItem = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.gm-level-0') : null;
        const movingToSub = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.gm-submenu') : null;

        if (movingToItem || movingToSub) {
            return;
        }

        clearTimeout(overlayDelay);
        hideDelay = setTimeout(() => {
            overlay.style.opacity = '0';
            setTimeout(() => {
                if (overlay.style.opacity === '0') {
                    overlay.style.display = 'none';
                }
            }, 300);
        }, 100);
    });
})();